import useCustomHook from '@/hooks/useCustomHook';
import { useEffect } from 'react';
import { defaultQuestionsPerScreen } from '@rockalingua/shared/activities/sortImages/constants';

export default function useSortImagesConf({ data, setConf = () => {} }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      questionsPerScreen: defaultQuestionsPerScreen,
      showBestStudents: true,
      questionTimer: 30,
      resultsTimer: 10,
    },
    actions: {
      setValue: (field, value) => {
        actions.setState({ [field]: value });
      },
    },
  });

  useEffect(() => {
    setConf(state);
  }, [state]);

  useEffect(() => {
    actions.setState({
      questionsPerScreen: data?.questionsPerScreen || defaultQuestionsPerScreen,
    });
  }, [data?.questionsPerScreen]);

  return { state, actions };
}
